export default {
  'productLibrary.tab.merchantTypes': 'Loại hình merchant',
  'productLibrary.tab.groups': 'Nhóm sản phẩm',
  'productLibrary.tab.sharedProducts': 'Sản phẩm dùng chung',
  'productLibrary.field.code': 'Mã',
  'productLibrary.field.name': 'Tên',
  'productLibrary.field.standardName': 'Tên chuẩn',
  'productLibrary.field.unit': 'Đơn vị',
  'productLibrary.field.invoiceItemType': 'Loại hàng hóa HĐ',
  'productLibrary.field.recommendedTax': 'Thuế gợi ý',
  'productLibrary.field.status': 'Trạng thái',
  'productLibrary.field.sortOrder': 'Thứ tự',
  'productLibrary.field.productGroups': 'Nhóm sản phẩm',
  'productLibrary.field.productCount': 'Số sản phẩm',
  'productLibrary.status.active': 'Hoạt động',
  'productLibrary.status.inactive': 'Tắt',
  'productLibrary.action.edit': 'Sửa',
  'productLibrary.action.remove': 'Gỡ',
  'productLibrary.action.addMerchantType': 'Thêm loại hình',
  'productLibrary.action.addGroup': 'Thêm nhóm',
  'productLibrary.action.addProduct': 'Thêm sản phẩm',
  'productLibrary.action.groupProducts': 'Sản phẩm trong nhóm',
  'productLibrary.title.editMerchantType': 'Cập nhật loại hình',
  'productLibrary.title.addMerchantType': 'Thêm loại hình merchant',
  'productLibrary.title.editGroup': 'Cập nhật nhóm sản phẩm',
  'productLibrary.title.addGroup': 'Thêm nhóm sản phẩm',
  'productLibrary.title.editProduct': 'Cập nhật sản phẩm',
  'productLibrary.title.addProduct': 'Thêm sản phẩm dùng chung',
  'productLibrary.toast.memberAdded': 'Đã thêm sản phẩm vào nhóm',
  'productLibrary.toast.memberRemoved': 'Đã gỡ sản phẩm khỏi nhóm',
  'productLibrary.toast.imported': 'Nhập dữ liệu thành công',
  'productLibrary.toast.saved': 'Đã lưu',
  'productLibrary.csv.invalidTitle': 'CSV không hợp lệ',
  'productLibrary.csv.row': 'Dòng',
  'productLibrary.csv.rows': 'dòng',
  'productLibrary.csv.validPreview':
    'Kiểm tra trước hợp lệ. Thao tác lưu là nguyên tử.',
  'productLibrary.action.importMembership': 'Nhập nhóm sản phẩm',
  'productLibrary.action.exportMembership': 'Xuất nhóm sản phẩm',
  'productLibrary.action.addToGroup': 'Thêm vào nhóm',
  'productLibrary.drawer.groupProducts': 'Sản phẩm trong nhóm',
  'productLibrary.drawer.help':
    'Tìm trong catalog dùng chung để thêm sản phẩm. Bảng bên dưới có phân trang; dùng CSV cho catalog lớn.',
  'productLibrary.drawer.searchProducts':
    'Tìm sản phẩm dùng chung theo mã hoặc tên',
  'productLibrary.drawer.searching': 'Đang tìm…',
  'productLibrary.drawer.searchHint': 'Nhập để tìm sản phẩm',
  'productLibrary.drawer.filterProducts': 'Lọc sản phẩm trong nhóm này',
  'productLibrary.form.merchantTypeGroupsHelp':
    'Merchant có loại hình này sẽ dùng được sản phẩm thuộc các nhóm đã chọn.',
  'productLibrary.form.selectGroups': 'Chọn một hoặc nhiều nhóm sản phẩm',
  'productLibrary.form.parentGroup': 'Nhóm cha',
  'productLibrary.form.groupHelp':
    'Quản lý sản phẩm bằng thao tác Sản phẩm trong nhóm hoặc nhập danh sách từ CSV.',
  'productLibrary.form.belongsToGroups': 'Thuộc nhóm sản phẩm',
  'productLibrary.form.productGroupsHelp':
    'Gán vào nhóm sản phẩm hoặc nhập danh sách từ CSV cho catalog lớn.',
  'csvImport.action.import': 'Nhập dữ liệu',
  'csvImport.action.downloadTemplate': 'Tải mẫu CSV',
  'csvImport.action.selectFile': 'Chọn tệp CSV',
  'pages.layouts.userLayout.title': 'Secure access to your financial dashboard',
  'pages.login.accountLogin.tab': 'Account Login',
  'pages.login.accountLogin.errorMessage':
    'Incorrect username/password(admin/ant.design)',
  'pages.login.failure': 'Login failed, please try again!',
  'pages.login.success': 'Login successful!',
  'pages.login.username.placeholder': 'Username',
  'pages.login.username.required': 'Please input your username!',
  'pages.login.password.placeholder': 'Password',
  'pages.login.password.required': 'Please input your password!',
  'pages.login.phoneLogin.tab': 'Phone Login',
  'pages.login.phoneLogin.errorMessage': 'Verification Code Error',
  'pages.login.phoneNumber.placeholder': 'Phone Number',
  'pages.login.phoneNumber.required': 'Please input your phone number!',
  'pages.login.phoneNumber.invalid': 'Phone number is invalid!',
  'pages.login.captcha.placeholder': 'Verification Code',
  'pages.login.captcha.required': 'Please input verification code!',
  'pages.login.phoneLogin.getVerificationCode': 'Get Code',
  'pages.getCaptchaSecondText': 'sec(s)',
  'pages.login.rememberMe': 'Remember me',
  'pages.login.forgotPassword': 'Forgot Password ?',
  'pages.login.submit': 'Login',
  'pages.login.loginWith': 'Login with :',
  'pages.login.registerAccount': 'Register Account',
  'pages.welcome.link': 'Welcome',
  'pages.welcome.alertMessage':
    'Faster and stronger heavy-duty components have been released.',
  'pages.404.subTitle': 'Sorry, the page you visited does not exist.',
  'pages.404.buttonText': 'Back Home',
  'pages.admin.subPage.title': 'This page can only be viewed by Admin',
  'pages.admin.subPage.alertMessage':
    'Umi ui is now released, welcome to use npm run ui to start the experience.',
  'pages.searchTable.createForm.newRule': 'New Rule',
  'pages.searchTable.updateForm.ruleConfig': 'Rule configuration',
  'pages.searchTable.updateForm.basicConfig': 'Basic Information',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'Rule Name',
  'pages.searchTable.updateForm.ruleName.nameRules':
    'Please enter the rule name!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'Rule Description',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder':
    'Please enter at least five characters',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    'Please enter a rule description of at least five characters!',
  'pages.searchTable.updateForm.ruleProps.title': 'Configure Properties',
  'pages.searchTable.updateForm.object': 'Monitoring Object',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'Rule Template',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'Rule Type',
  'pages.searchTable.updateForm.schedulingPeriod.title':
    'Set Scheduling Period',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Starting Time',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules':
    'Please choose a start time!',
  'pages.searchTable.titleDesc': 'Description',
  'pages.searchTable.ruleName': 'Rule name is required',
  'pages.searchTable.titleCallNo': 'Number of Service Calls',
  'pages.searchTable.titleStatus': 'Status',
  'pages.searchTable.nameStatus.default': 'default',
  'pages.searchTable.nameStatus.running': 'running',
  'pages.searchTable.nameStatus.online': 'online',
  'pages.searchTable.nameStatus.abnormal': 'abnormal',
  'pages.searchTable.titleUpdatedAt': 'Last Scheduled at',
  'pages.searchTable.exception': 'Please enter the reason for the exception!',
  'pages.searchTable.titleOption': 'Option',
  'pages.searchTable.config': 'Configuration',
  'pages.searchTable.subscribeAlert': 'Subscribe to alerts',
  'pages.searchTable.title': 'Enquiry Form',
  'pages.searchTable.new': 'New',
  'pages.searchTable.chosen': 'chosen',
  'pages.searchTable.item': 'item',
  'pages.searchTable.totalServiceCalls': 'Total Number of Service Calls',
  'pages.searchTable.tenThousand': '0000',
  'pages.searchTable.batchDeletion': 'batch deletion',
  'pages.searchTable.batchApproval': 'batch approval',
  'ra.auth.sign_in': 'Đăng nhập',
  'ra.auth.username': 'Tên đăng nhập',
  'ra.auth.password': 'Mật khẩu',
  'text.forgotPassword': 'Quên mật khẩu?',
  'text.enterOtp': 'Vui lòng nhập mã 2FA',
  'text.verifyOtp': 'Xác thực OTP',
  'text.welcome': 'Xin chào, {name}',
  'text.back': 'Quay lại',
  'text.otp': 'Mã OTP (6 chữ số)',
  'text.otpRequired': 'Vui lòng nhập OTP',
  'text.otpLen': 'OTP phải gồm 6 chữ số',
  'text.invalidCredential': 'Sai tên đăng nhập hoặc mật khẩu',
  'text.loginSuccess': 'Đăng nhập thành công',
  'text.otpFailed': 'Xác thực OTP thất bại',
  'text.user': 'Người dùng',
  'common.validation.maxChars': 'Tối đa {max} ký tự',
  'common.validation.minChars': 'Tối thiểu {min} ký tự',
  'app.sessionExpired': 'Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại.',
  'error.userPasswordReused':
    'Mật khẩu mới không được trùng với 24 mật khẩu gần nhất',
  'auth.password.required.new': 'Vui lòng nhập mật khẩu mới',
  'auth.password.required.confirm': 'Vui lòng xác nhận mật khẩu',
  'auth.password.rule':
    'Mật khẩu phải dài 16-65 ký tự và gồm chữ cái, số, ký tự đặc biệt.',
  'auth.password.mismatch': 'Mật khẩu xác nhận không khớp',
  'auth.otp.label': 'OTP',
  'auth.otp.required': 'Vui lòng nhập OTP',
  'auth.otp.length': 'OTP phải gồm 6 chữ số',
  'auth.otp.placeholder': 'Mã OTP (6 chữ số)',
  'auth.email.required': 'Vui lòng nhập email',
  'auth.email.invalid': 'Định dạng email không hợp lệ',
  'auth.backToLogin': 'Quay lại đăng nhập',
  'setup.title': 'Khởi Tạo Admin',
  'setup.subtitle.token': 'Xác thực quyền khởi tạo.',
  'setup.subtitle.admin': 'Tài khoản admin',
  'setup.error.unavailable':
    'Không thể khởi tạo vì đã tồn tại admin được kích hoạt.',
  'setup.error.checkFailed': 'Kiểm tra bootstrap token thất bại',
  'setup.error.initFailed': 'Khởi tạo admin thất bại',
  'setup.form.token': 'Bootstrap token',
  'setup.form.token.required': 'Vui lòng nhập bootstrap token',
  'setup.form.login': 'Tên đăng nhập',
  'setup.form.firstName': 'Tên',
  'setup.form.lastName': 'Họ',
  'setup.form.language': 'Ngôn ngữ',
  'setup.button.continue': 'Tiếp tục',
  'setup.button.sendActivation': 'Gửi email kích hoạt',
  'setup.status.expiresAt': 'Token hết hạn lúc',
  'setup.notice.sent': 'Đã gửi email kích hoạt',
  'forget.title': 'Quên Mật Khẩu',
  'forget.subtitle': 'Nhập email tài khoản để nhận liên kết đặt lại mật khẩu.',
  'forget.notice.generic':
    'Nếu tồn tại tài khoản cho địa chỉ email này, hướng dẫn đặt lại mật khẩu sẽ được gửi.',
  'forget.button.send': 'Gửi liên kết đặt lại',
  'reset.title': 'Đặt Lại Mật Khẩu',
  'reset.subtitle': 'Thiết lập mật khẩu mới cho tài khoản của bạn.',
  'reset.error.missingKey':
    'Thiếu reset key. Vui lòng dùng liên kết đặt lại mật khẩu từ email.',
  'reset.error.failed': 'Đặt lại mật khẩu thất bại',
  'reset.button.submit': 'Đặt lại mật khẩu',
  'reset.success':
    'Đặt lại mật khẩu thành công. Bạn có thể đăng nhập bằng mật khẩu mới.',
  'activate.title': 'Kích Hoạt Tài Khoản',
  'activate.subtitle.setPassword':
    'Đặt mật khẩu tài khoản để tiếp tục kích hoạt.',
  'activate.subtitle.verifyOtp': 'Quét QR ứng dụng xác thực và nhập OTP.',
  'activate.subtitle.done':
    'Tài khoản đã kích hoạt và cấu hình 2FA thành công.',
  'activate.error.missingKey':
    'Thiếu activation key. Vui lòng dùng liên kết kích hoạt từ email.',
  'activate.error.failed': 'Kích hoạt tài khoản thất bại',
  'activate.error.otpFailed': 'Xác thực OTP thất bại',
  'activate.qr.unavailable':
    'Không có URL cấu hình Authenticator. Vui lòng liên hệ hỗ trợ.',
  'activate.qr.copyCode': 'Sao chép',
  'activate.button.submit': 'Kích hoạt tài khoản',
  'activate.button.verify': 'Xác thực và hoàn tất',
  'activate.done.success':
    'Kích hoạt thành công. Bạn có thể đăng nhập ngay bây giờ.',
  'passwordExpired.title': 'Mật Khẩu Đã Hết Hạn',
  'passwordExpired.subtitle':
    'Vui lòng cập nhật mật khẩu để tiếp tục. Cần OTP hợp lệ.',
  'passwordExpired.error.missingEmail':
    'Thiếu email. Vui lòng thực hiện đăng nhập lại.',
  'passwordExpired.error.failed': 'Cập nhật mật khẩu thất bại',
  'passwordExpired.error.tokenMissing':
    'Đổi mật khẩu thành công nhưng thiếu token đăng nhập',
  'passwordExpired.form.email': 'Email',
  'passwordExpired.form.currentPassword': 'Mật khẩu hiện tại',
  'passwordExpired.button.submit': 'Cập nhật mật khẩu',
  'account.settings.title': 'Cài Đặt Tài Khoản',
  'account.settings.subtitle':
    'Cập nhật thông tin hồ sơ và thông tin bảo mật của bạn.',
  'account.profile.cardTitle': 'Hồ Sơ',
  'account.profile.firstName': 'Tên',
  'account.profile.lastName': 'Họ',
  'account.profile.imageUrl': 'URL Ảnh Đại Diện',
  'account.profile.lang': 'Ngôn ngữ',
  'account.profile.lang.en': 'English',
  'account.profile.lang.vi': 'Tiếng Việt',
  'account.profile.button.save': 'Lưu hồ sơ',
  'account.profile.success': 'Cập nhật hồ sơ thành công.',
  'account.profile.error.failed': 'Cập nhật hồ sơ thất bại',
  'account.validation.firstNameRequired': 'Vui lòng nhập tên',
  'account.validation.lastNameRequired': 'Vui lòng nhập họ',
  'account.security.cardTitle': 'Bảo Mật',
  'account.security.currentPassword': 'Mật khẩu hiện tại',
  'account.security.newPassword': 'Mật khẩu mới',
  'account.security.confirmPassword': 'Xác nhận mật khẩu mới',
  'account.security.button.change': 'Đổi mật khẩu',
  'account.security.success': 'Đổi mật khẩu thành công.',
  'account.security.error.failed': 'Đổi mật khẩu thất bại',
  'account.validation.currentPasswordRequired':
    'Vui lòng nhập mật khẩu hiện tại',
  'account.center.title': 'Trung Tâm Tài Khoản',
  'account.center.subtitle': 'Xem tóm tắt hồ sơ và trạng thái bảo mật.',
  'account.center.profile.title': 'Tổng Quan Hồ Sơ',
  'account.center.security.title': 'Trạng Thái Bảo Mật',
  'account.center.button.openSettings': 'Mở cài đặt',
  'account.center.field.fullName': 'Họ tên',
  'account.center.field.login': 'Tài khoản đăng nhập',
  'account.center.field.email': 'Email',
  'account.center.field.language': 'Ngôn ngữ',
  'account.center.field.avatarUrl': 'URL ảnh đại diện',
  'account.center.field.activated': 'Kích hoạt',
  'account.center.field.twofa': '2FA',
  'account.center.field.lastModified': 'Cập nhật lần cuối',
  'account.center.field.created': 'Ngày tạo',
  'account.center.value.yes': 'Có',
  'account.center.value.no': 'Không',
  'account.center.value.twofaEnabledAfterActivation': 'Bật sau khi kích hoạt',
  'account.center.error.loadFailed': 'Không tải được thông tin tài khoản',
  'admin.common.search': 'Tìm kiếm',
  'admin.common.actions': 'Thao tác',
  'admin.common.edit': 'Sửa',
  'admin.common.delete': 'Xóa',
  'admin.common.yes': 'Có',
  'admin.common.no': 'Không',
  'admin.common.save': 'Lưu',
  'admin.common.reset': 'Làm lại',
  'admin.common.saved': 'Đã lưu',
  'admin.common.saveFailed': 'Lưu thất bại',
  'admin.users.title': 'Người dùng',
  'admin.users.action.create': 'Tạo người dùng',
  'admin.users.action.resendActivation': 'Gửi lại kích hoạt',
  'admin.users.action.forgotPassword': 'Quên mật khẩu',
  'admin.users.field.login': 'Tài khoản đăng nhập',
  'admin.users.field.firstName': 'Tên',
  'admin.users.field.lastName': 'Họ',
  'admin.users.field.activated': 'Kích hoạt',
  'admin.users.field.roles': 'Vai trò',
  'admin.users.confirm.delete': 'Xóa người dùng này?',
  'admin.users.modal.createTitle': 'Tạo Người Dùng',
  'admin.users.modal.editTitle': 'Sửa Người Dùng',
  'admin.users.toast.loadUserFailed': 'Tải người dùng thất bại',
  'admin.users.toast.created': 'Tạo người dùng thành công',
  'admin.users.toast.updated': 'Cập nhật người dùng thành công',
  'admin.users.toast.deleted': 'Xóa người dùng thành công',
  'admin.users.toast.deleteFailed': 'Xóa người dùng thất bại',
  'admin.users.toast.resendActivationSuccess': 'Đã gửi lại email kích hoạt',
  'admin.users.toast.resendActivationFailed':
    'Gửi lại email kích hoạt thất bại',
  'admin.users.toast.notEligibleReset':
    'Người dùng không đủ điều kiện reset mật khẩu',
  'admin.users.toast.sentForgotPassword':
    'Đã gửi email quên mật khẩu cho người dùng',
  'admin.users.toast.sendForgotPasswordFailed':
    'Gửi email quên mật khẩu thất bại',
  'admin.roles.title': 'Vai trò',
  'admin.roles.field.name': 'Tên vai trò',
  'admin.roles.field.active': 'Hoạt động',
  'admin.roles.action.add': 'Thêm vai trò',
  'admin.roles.action.addUser': 'Thêm người dùng',
  'admin.roles.action.removeUser': 'Xóa',
  'admin.roles.value.active': 'Hoạt động',
  'admin.roles.value.disabled': 'Vô hiệu',
  'admin.roles.modal.createTitle': 'Tạo Vai Trò',
  'admin.roles.modal.editTitle': 'Sửa Vai Trò',
  'admin.roles.validation.nameRequired': 'Vui lòng nhập tên vai trò',
  'admin.roles.detail.title': 'Chi tiết vai trò',
  'admin.roles.detail.selectHint': 'Chọn một vai trò để xem chi tiết',
  'admin.roles.detail.loading': 'Đang tải vai trò...',
  'admin.roles.detail.notFound': 'Không tìm thấy vai trò',
  'admin.roles.detail.roleName': 'Vai trò: {name}',
  'admin.roles.permissions.title': 'Quyền',
  'admin.roles.permissions.selectAllSubMenus': 'Chọn tất cả submenu',
  'admin.roles.permissions.selectPlaceholder': 'Chọn quyền...',
  'admin.roles.permissions.selectAll': 'Chọn tất cả',
  'admin.roles.permissions.loadFailed': 'Tải danh sách quyền thất bại',
  'admin.roles.placeholder.searchUser': 'Tìm người dùng...',
  'admin.roles.toast.created': 'Tạo vai trò thành công',
  'admin.roles.toast.updated': 'Cập nhật vai trò thành công',
  'admin.roles.toast.loadFailed': 'Tải danh sách vai trò thất bại',
  'admin.roles.toast.userAdded': 'Thêm người dùng thành công',
  'admin.roles.toast.userAddFailed': 'Thêm người dùng thất bại',
  'admin.roles.toast.userRemoved': 'Xóa người dùng khỏi vai trò thành công',
  'admin.roles.toast.userRemoveFailed': 'Xóa người dùng thất bại',
  'admin.roles.toast.activated': 'Kích hoạt vai trò thành công',
  'admin.roles.toast.disabled': 'Vô hiệu vai trò thành công',
  'admin.roles.toast.changeStatusFailed': 'Đổi trạng thái vai trò thất bại',
  'branches.title': 'Chi nhánh',
  'branches.field.name': 'Tên',
  'branches.field.code': 'Mã',
  'branches.field.parent': 'Chi nhánh cha',
  'branches.field.address': 'Địa chỉ',
  'branches.field.phone': 'Số điện thoại',
  'branches.field.level': 'Cấp',
  'branches.action.add': 'Thêm',
  'branches.action.activate': 'Kích hoạt',
  'branches.action.disable': 'Vô hiệu',
  'branches.value.active': 'Hoạt động',
  'branches.value.disabled': 'Vô hiệu',
  'branches.empty.select': 'Chọn một chi nhánh',
  'branches.placeholder.search': 'Tìm kiếm chi nhánh...',
  'branches.placeholder.root': 'Gốc (không có chi nhánh cha)',
  'branches.modal.createTitle': 'Tạo chi nhánh',
  'branches.modal.editTitle': 'Sửa chi nhánh',
  'branches.validation.nameRequired': 'Vui lòng nhập tên chi nhánh',
  'branches.confirm.activateTitle': 'Kích hoạt chi nhánh?',
  'branches.confirm.activateContent':
    'Bạn có chắc muốn kích hoạt "{name}" không?',
  'branches.confirm.disableTitle': 'Vô hiệu chi nhánh?',
  'branches.confirm.disableContent': 'Bạn có chắc muốn vô hiệu "{name}" không?',
  'branches.confirm.deleteTitle': 'Xóa chi nhánh?',
  'branches.confirm.deleteContent':
    'Bạn có chắc muốn xóa "{name}" không? Hành động này không thể hoàn tác.',
  'branches.toast.loadFailed': 'Tải danh sách chi nhánh thất bại',
  'branches.toast.created': 'Tạo chi nhánh thành công',
  'branches.toast.updated': 'Cập nhật chi nhánh thành công',
  'branches.toast.deleted': 'Xóa chi nhánh thành công',
  'branches.toast.activated': 'Kích hoạt chi nhánh thành công',
  'branches.toast.disabled': 'Vô hiệu chi nhánh thành công',
  'merchants.title': 'Merchant',
  'merchants.field.branch': 'Chi nhánh',
  'merchants.field.legalName': 'Tên pháp lý',
  'merchants.field.status': 'Trạng thái',
  'merchants.field.city': 'Thành phố',
  'merchants.field.state': 'Tỉnh/Bang',
  'merchants.field.zipCode': 'Mã ZIP',
  'merchants.field.industryCode': 'Mã ngành',
  'merchants.field.categoryCode': 'Mã danh mục',
  'merchants.field.supportPhone': 'SĐT hỗ trợ',
  'merchants.field.loyalty': 'Loyalty',
  'merchants.field.loyaltyEnabled': 'Bật loyalty',
  'merchants.field.loyaltyEarnRatePercent': 'Tỷ lệ tích điểm loyalty (%)',
  'merchants.field.maxAmountPerTransaction': 'Hạn mức mỗi giao dịch',
  'merchants.field.maxTotalAmountPerDay': 'Tổng hạn mức mỗi ngày',
  'merchants.field.maxTotalAmountPerMonth': 'Tổng hạn mức mỗi tháng',
  'merchants.action.create': 'Tạo merchant',
  'merchants.action.activate': 'Kích hoạt',
  'merchants.action.disable': 'Vô hiệu',
  'merchants.value.active': 'Hoạt động',
  'merchants.value.disabled': 'Vô hiệu',
  'merchants.placeholder.selectBranch': 'Chọn chi nhánh',
  'merchants.placeholder.allBranches': 'Tất cả chi nhánh',
  'merchants.modal.createTitle': 'Tạo merchant',
  'merchants.modal.editTitle': 'Sửa merchant',
  'merchants.validation.legalNameRequired': 'Vui lòng nhập tên pháp lý',
  'merchants.validation.loyaltyEarnRateRequired':
    'Vui lòng nhập tỷ lệ tích điểm loyalty',
  'merchants.confirm.activateTitle': 'Kích hoạt merchant?',
  'merchants.confirm.activateContent':
    'Bạn có chắc muốn kích hoạt "{name}" không?',
  'merchants.confirm.disableTitle': 'Vô hiệu merchant?',
  'merchants.confirm.disableContent':
    'Bạn có chắc muốn vô hiệu "{name}" không?',
  'merchants.confirm.deleteTitle': 'Xóa merchant?',
  'merchants.confirm.deleteContent': 'Bạn có chắc muốn xóa "{name}" không?',
  'merchants.toast.loadFailed': 'Tải merchant thất bại',
  'merchants.toast.created': 'Tạo merchant thành công',
  'merchants.toast.updated': 'Cập nhật merchant thành công',
  'merchants.toast.deleted': 'Xóa merchant thành công',
  'merchants.toast.deleteFailed': 'Xóa merchant thất bại',
  'merchants.toast.activated': 'Kích hoạt merchant thành công',
  'merchants.toast.disabled': 'Vô hiệu merchant thành công',
  'merchants.toast.changeStatusFailed': 'Đổi trạng thái thất bại',
  'merchants.action.einvoice': 'Hóa đơn ĐT',
  'merchants.modal.einvoiceTitle': 'Cấu hình hóa đơn điện tử',
  'merchants.field.taxCode': 'Mã số thuế (MST)',
  'merchants.field.einvoiceProvider': 'Nhà cung cấp hóa đơn điện tử',
  'merchants.field.einvoiceConnector': 'Connector',
  'merchants.field.einvoiceTemplate': 'Mẫu hóa đơn',
  'merchants.field.einvoiceSerial': 'Ký hiệu hóa đơn',
  'merchants.einvoice.taxCodeHint':
    'MST người bán — bắt buộc để đơn hàng đủ điều kiện phát hành hóa đơn điện tử',
  'merchants.validation.taxCodeRequired': 'Vui lòng nhập mã số thuế',
  'merchants.validation.taxCodeFormat': '8-20 ký tự: chữ, số hoặc gạch ngang',
  'merchants.toast.einvoiceConfigured':
    'Cập nhật cấu hình hóa đơn điện tử thành công',
  'einvoices.title': 'Quản lý hóa đơn',
  'einvoices.remediation.title': 'Cần xử lý',
  'einvoices.field.createdDate': 'Thời gian',
  'einvoices.field.merchant': 'Merchant',
  'einvoices.field.merchantSearch': 'Tên, mã merchant…',
  'einvoices.field.transactionId': 'Mã giao dịch',
  'einvoices.field.transactionIdSearch': 'Mã giao dịch…',
  'einvoices.field.invoiceNo': 'Số HĐ',
  'einvoices.field.invoiceNoSearch': 'Số hóa đơn…',
  'einvoices.field.serial': 'Ký hiệu',
  'einvoices.field.status': 'Trạng thái',
  'einvoices.field.taxStatus': 'Trạng thái CQT',
  'einvoices.field.totalAmount': 'Tổng tiền',
  'einvoices.field.reasonCode': 'Mã lý do',
  'einvoices.field.note': 'Ghi chú',
  'einvoices.field.notePlaceholder': 'Nhập ghi chú xử lý',
  'einvoices.filter.dateRange': 'Thời gian',
  'einvoices.filter.fromDate': 'Từ ngày',
  'einvoices.filter.toDate': 'Đến ngày',
  'einvoices.filter.statuses': 'Trạng thái',
  'einvoices.filter.statusesPlaceholder': 'Chọn trạng thái',
  'einvoices.filter.taxStatuses': 'Trạng thái CQT',
  'einvoices.filter.taxStatusesPlaceholder': 'Chọn trạng thái CQT',
  'einvoices.tab.invoices': 'Hóa đơn',
  'einvoices.tab.remediations': 'Cần xử lý',
  'einvoices.tab.test': 'Kiểm tra',
  'einvoices.action.retry': 'Thử phát hành lại hóa đơn',
  'einvoices.action.suppress': 'Bỏ qua mục này',
  'einvoices.action.resolve': 'Đã xử lý ngoài hệ thống',
  'einvoices.remediation.status.open': 'Đang mở',
  'einvoices.remediation.status.suppressed': 'Đã bỏ qua',
  'einvoices.remediation.status.resolved': 'Đã xử lý',
  'einvoices.toast.updated': 'Đã cập nhật',
  'einvoices.error.downloadPdf': 'Không tải được PDF hóa đơn',
  'einvoices.error.viewPdf': 'Không xem được PDF hóa đơn',
  'einvoices.error.update': 'Không cập nhật được mục này',
  'einvoices.pdf.title': 'PDF hóa đơn',
  'partnerCredentials.title': 'Partner Credentials',
  'partnerCredentials.field.name': 'Tên',
  'partnerCredentials.field.clientId': 'Client ID',
  'partnerCredentials.field.outboundClientId': 'Outbound Client ID',
  'partnerCredentials.field.inboundClientSecret': 'Inbound Client Secret',
  'partnerCredentials.field.outboundClientSecret': 'Outbound Client Secret',
  'partnerCredentials.field.inboundClientSecretInput':
    'Inbound Client Secret (tùy chọn)',
  'partnerCredentials.field.outboundClientSecretInput':
    'Outbound Client Secret (tùy chọn)',
  'partnerCredentials.field.outboundUrl': 'Outbound URL',
  'partnerCredentials.placeholder.secretUnchanged':
    'Äá»ƒ trá»‘ng Ä‘á»ƒ giá»¯ nguyÃªn secret hiá»‡n táº¡i',
  'partnerCredentials.field.inboundSignatureAlgorithm':
    'Inbound Signature Algorithm',
  'partnerCredentials.field.outboundSignatureAlgorithm':
    'Outbound Signature Algorithm',
  'partnerCredentials.field.status': 'Trạng thái',
  'partnerCredentials.action.create': 'Tạo',
  'partnerCredentials.value.active': 'Hoạt động',
  'partnerCredentials.value.disabled': 'Vô hiệu',
  'partnerCredentials.modal.createTitle': 'Tạo partner credential',
  'partnerCredentials.modal.editTitle': 'Sửa partner credential',
  'partnerCredentials.modal.createdTitle': 'Đã tạo credentials',
  'partnerCredentials.modal.createdDescription':
    'Credentials này chỉ hiển thị một lần và đã được copy vào clipboard. Hãy lưu an toàn.',
  'partnerCredentials.modal.confirmSaved': 'OK, tôi đã lưu',
  'partnerCredentials.validation.nameRequired': 'Vui lòng nhập tên',
  'partnerCredentials.confirm.deleteTitle': 'Xóa partner credential?',
  'partnerCredentials.confirm.deleteContent':
    'Bạn có chắc muốn xóa "{name}" không?',
  'partnerCredentials.toast.created': 'Tạo partner credential thành công',
  'partnerCredentials.toast.updated': 'Cập nhật partner credential thành công',
  'partnerCredentials.toast.deleted': 'Xóa partner credential thành công',
  'loyalty.policy.title': 'Loyalty Policy',
  'loyalty.customer.detail.title': 'Chi tiết điểm khách hàng',
  'loyalty.customer.detail.rewards': 'Điểm thưởng theo merchant',
  'loyalty.customer.detail.back': 'Quay lại danh sách khách hàng',
  'loyalty.policy.version': 'Phiên bản policy',
  'loyalty.policy.text': 'Nội dung policy',
  'loyalty.policy.active': 'Hoạt động',
  'loyalty.policy.effectiveFrom': 'Hiệu lực từ',
  'loyalty.policy.publicUrl': 'Public URL',
  'loyalty.policy.action.create': 'Tạo policy',
  'loyalty.policy.modal.createTitle': 'Tạo policy',
  'loyalty.policy.modal.editTitle': 'Sửa policy',
  'loyalty.policy.preview': 'Xem trước',
  'loyalty.policy.updated': 'Cập nhật policy thành công',
  'loyalty.policy.validation.versionRequired': 'Vui lòng nhập phiên bản policy',
  'loyalty.policy.validation.textRequired': 'Vui lòng nhập nội dung policy',
  'banks.title': 'Ngân hàng',
  'banks.field.code': 'Mã',
  'banks.field.name': 'Tên',
  'banks.field.host': 'Host',
  'banks.field.port': 'Port',
  'banks.field.timeoutMs': 'Timeout (ms)',
  'banks.field.status': 'Trạng thái',
  'banks.field.active': 'Hoạt động',
  'banks.action.create': 'Tạo ngân hàng',
  'banks.action.activate': 'Kích hoạt',
  'banks.action.disable': 'Vô hiệu',
  'banks.value.active': 'Hoạt động',
  'banks.value.disabled': 'Vô hiệu',
  'banks.modal.createTitle': 'Tạo ngân hàng',
  'banks.modal.editTitle': 'Sửa ngân hàng',
  'banks.validation.codeRequired': 'Vui lòng chọn mã ngân hàng',
  'banks.validation.nameRequired': 'Vui lòng nhập tên ngân hàng',
  'banks.validation.hostRequired': 'Vui lòng nhập host',
  'banks.validation.portRequired': 'Vui lòng nhập port',
  'banks.validation.noCodeAvailable': 'Tất cả mã ngân hàng đã được sử dụng.',
  'banks.confirm.activateTitle': 'Kích hoạt ngân hàng?',
  'banks.confirm.activateContent': 'Bạn có chắc muốn kích hoạt "{name}" không?',
  'banks.confirm.disableTitle': 'Vô hiệu ngân hàng?',
  'banks.confirm.disableContent': 'Bạn có chắc muốn vô hiệu "{name}" không?',
  'banks.toast.created': 'Tạo ngân hàng thành công',
  'banks.toast.updated': 'Cập nhật ngân hàng thành công',
  'banks.toast.activated': 'Kích hoạt ngân hàng thành công',
  'banks.toast.disabled': 'Vô hiệu ngân hàng thành công',
  'dashboard.title': 'Bảng điều khiển',
  'dashboard.common.noData': 'Không có dữ liệu',
  'dashboard.dateRange.today': 'Hôm nay',
  'dashboard.dateRange.thisWeek': 'Tuần này',
  'dashboard.dateRange.thisMonth': 'Tháng này',
  'dashboard.overview.totalMerchants': 'Tổng merchant',
  'dashboard.overview.totalTerminals': 'Tổng terminal',
  'dashboard.overview.transactions': 'Giao dịch',
  'dashboard.overview.totalAmount': 'Tổng giá trị',
  'dashboard.overview.active': 'hoạt động',
  'dashboard.overview.inactive': 'không hoạt động',
  'dashboard.overview.enrolled': 'đã enroll',
  'dashboard.overview.activeCapitalized': 'Hoạt động',
  'dashboard.overview.inactiveCapitalized': 'Không hoạt động',
  'dashboard.overview.enrolledCapitalized': 'Đã enroll',
  'dashboard.overview.avg': 'TB: {value}',
  'dashboard.overview.placeholder': 'placeholder',
  'dashboard.trend.title': 'Xu hướng giao dịch',
  'dashboard.trend.granularity.day': 'Ngày',
  'dashboard.trend.granularity.week': 'Tuần',
  'dashboard.trend.granularity.month': 'Tháng',
  'dashboard.trend.metric.count': 'Số lượng',
  'dashboard.trend.metric.amount': 'Giá trị',
  'dashboard.trend.series.transactions': 'Giao dịch',
  'dashboard.trend.series.amount': 'Giá trị',
  'dashboard.distribution.byStatus': 'Theo trạng thái',
  'dashboard.distribution.byPaymentType': 'Theo loại thanh toán',
  'dashboard.distribution.byTransactionType': 'Theo loại giao dịch',
  'dashboard.status.merchantTitle': 'Trạng thái merchant',
  'dashboard.status.terminalTitle': 'Trạng thái terminal',
  'dashboard.topMerchants.title': 'Top merchant theo số lượng giao dịch',
  'transactions.title': 'Giao dịch',
  'transactions.page.title': 'Hoạt động giao dịch',
  'transactions.page.description':
    'Các bút toán giao dịch thời gian thực và log quyết toán',
  'transactions.tab.all': 'Tất cả',
  'transactions.tab.authorized': 'Đã ủy quyền',
  'transactions.tab.settled': 'Đã quyết toán',
  'transactions.tab.declined': 'Từ chối',
  'transactions.tab.error': 'Lỗi',
  'transactions.tab.batchSummary': 'Tổng hợp batch',
  'transactions.batchList.title': 'Batches',
  'transactions.batchList.description':
    'Quản lý và đối soát các batch giao dịch trên terminal đã kết nối.',
  'transactions.batchList.statusTab.all': 'Tất cả batch',
  'transactions.batchList.statusTab.open': 'Open',
  'transactions.batchList.statusTab.processing': 'Processing',
  'transactions.batchList.statusTab.settled': 'Settled',
  'transactions.field.transactionNo': 'Mã giao dịch',
  'transactions.field.batchId': 'Batch ID',
  'transactions.field.batchNumber': 'Batch No',
  'transactions.field.merchant': 'Merchant',
  'transactions.field.terminal': 'Terminal',
  'transactions.field.epi': 'EPI',
  'transactions.field.authCode': 'Mã auth',
  'transactions.field.cardNumber': 'Số thẻ',
  'transactions.field.customerName': 'Tên khách hàng',
  'transactions.field.amount': 'Số tiền',
  'transactions.field.paymentType': 'Loại thanh toán',
  'transactions.field.transactionType': 'Loại giao dịch',
  'transactions.field.status': 'Trạng thái',
  'transactions.field.responseCode': 'Mã phản hồi',
  'transactions.field.processorResponse': 'Phản hồi processor',
  'transactions.field.actions': 'Thao tác',
  'transactions.field.transactionDate': 'Ngày giao dịch',
  'transactions.field.batchDate': 'Ngày batch',
  'transactions.field.settledDate': 'Ngày quyết toán',
  'transactions.field.batchStatus': 'Trạng thái batch',
  'transactions.field.paymentCount': 'Số giao dịch',
  'transactions.field.grossSales': 'Tổng doanh số',
  'transactions.field.settledCount': 'Số lượng quyết toán',
  'transactions.field.settledAmount': 'Số tiền quyết toán',
  'transactions.field.currentBatch': 'Batch hiện tại',
  'transactions.field.processor': 'Processor',
  'transactions.field.transactionTime': 'Thời gian',
  'transactions.field.transactionDatePreset': 'Ngày giao dịch',
  'transactions.field.transactionDateCustom': 'Khoảng ngày tùy chỉnh',
  'transactions.field.fromDate': 'Từ ngày',
  'transactions.field.toDate': 'Đến ngày',
  'transactions.field.fromAmount': 'Từ số tiền',
  'transactions.field.toAmount': 'Đến số tiền',
  'transactions.placeholder.fromAmount': 'Số tiền tối thiểu',
  'transactions.placeholder.toAmount': 'Số tiền tối đa',
  'transactions.placeholder.selectTerminal': 'Chọn terminal',
  'transactions.placeholder.selectMerchant': 'Chọn merchant',
  'transactions.placeholder.searchMerchant': 'Tìm merchant',
  'transactions.placeholder.searchTerminal': 'Tìm terminal',
  'transactions.placeholder.searchTransactionId': 'Tìm transaction id',
  'transactions.placeholder.searchAuthCode': 'Tìm mã auth',
  'transactions.placeholder.searchCardNumber': 'Tìm số thẻ',
  'transactions.placeholder.searchCustomerName': 'Tìm tên chủ thẻ',
  'transactions.placeholder.searchStatus': 'Tìm trạng thái...',
  'transactions.placeholder.searchPaymentType': 'Tìm loại thanh toán...',
  'transactions.placeholder.searchTransactionType': 'Tìm loại giao dịch...',
  'transactions.placeholder.searchBatchId': 'Tìm batch id',
  'transactions.placeholder.searchBatchNumber': 'Tìm batch no',
  'transactions.placeholder.searchBatchStatus': 'Tìm trạng thái batch...',
  'transactions.placeholder.selectProcessor': 'Chọn processor',
  'transactions.empty.noTerminal': 'Không tìm thấy terminal',
  'transactions.empty.noMerchant': 'Không tìm thấy merchant',
  'transactions.value.active': 'Hoạt động',
  'transactions.value.inactive': 'Không hoạt động',
  'transactions.value.batchStatus.open': 'Open',
  'transactions.value.batchStatus.processing': 'Processing',
  'transactions.value.batchStatus.settled': 'Settled',
  'transactions.value.batchStatus.paused': 'Paused',
  'transactions.preset.custom': 'Ngày giao dịch tùy chỉnh',
  'transactions.preset.past365Days': '365 ngày gần đây',
  'transactions.preset.past180Days': '180 ngày gần đây',
  'transactions.preset.past90Days': '90 ngày gần đây',
  'transactions.preset.past30Days': '30 ngày gần đây',
  'transactions.preset.past7Days': '7 ngày gần đây',
  'transactions.preset.past3Days': '3 ngày gần đây',
  'transactions.preset.lastYear': 'Năm trước',
  'transactions.preset.lastQuarter': 'Quý trước',
  'transactions.preset.lastMonth': 'Tháng trước',
  'transactions.preset.lastWeek': 'Tuần trước',
  'transactions.preset.yesterday': 'Hôm qua',
  'transactions.preset.thisYear': 'Năm nay',
  'transactions.preset.thisQuarter': 'Quý này',
  'transactions.preset.thisMonth': 'Tháng này',
  'transactions.preset.thisWeek': 'Tuần này',
  'transactions.preset.today': 'Hôm nay',
  'transactions.action.view': 'Xem',
  'transactions.action.cancel': 'Hủy',
  'transactions.action.apply': 'Áp dụng',
  'transactions.receipt.action.view': 'Xem receipt',
  'transactions.receipt.action.download': 'Tải receipt',
  'transactions.receipt.action.sendEmail': 'Gửi receipt qua email',
  'transactions.receipt.previewModal.title': 'Receipt',
  'transactions.receipt.public.title': 'Hóa đơn thanh toán',
  'transactions.receipt.public.merchantFallback': 'Payment Hub',
  'transactions.receipt.public.amount': 'Số tiền',
  'transactions.receipt.public.transactionTime': 'Thời gian giao dịch',
  'transactions.receipt.public.preparing': 'Đang chuẩn bị hóa đơn',
  'transactions.receipt.public.preparingDesc':
    'Vui lòng kiểm tra lại liên kết này sau khi hóa đơn sẵn sàng.',
  'transactions.receipt.public.notFound': 'Không tìm thấy hóa đơn',
  'transactions.receipt.public.notFoundDesc':
    'Liên kết hóa đơn không hợp lệ hoặc đã hết hạn.',
  'transactions.receipt.public.download': 'Tải hóa đơn',
  'transactions.receipt.public.email': 'Email',
  'transactions.receipt.public.emailPlaceholder': 'example@email.com',
  'transactions.receipt.public.emailRequired': 'Nhập địa chỉ email',
  'transactions.receipt.public.emailInvalid': 'Nhập địa chỉ email hợp lệ',
  'transactions.receipt.public.sendEmail': 'Gửi hóa đơn qua email',
  'transactions.receipt.public.emailSent': 'Đã gửi email hóa đơn',
  'transactions.receipt.public.emailFailed':
    'Không thể gửi email hóa đơn. Vui lòng thử lại sau.',
  'transactions.receipt.emailModal.title': 'Gửi receipt qua email',
  'transactions.receipt.emailModal.send': 'Gửi',
  'transactions.receipt.emailModal.recipients': 'Email nhận',
  'transactions.receipt.emailModal.placeholder':
    'customer@example.com, second@example.com',
  'transactions.receipt.validation.emailRequired':
    'Vui lòng nhập ít nhất một email',
  'transactions.receipt.validation.emailInvalid': 'Vui lòng nhập email hợp lệ',
  'transactions.receipt.toast.emailSent': 'Đã gửi receipt qua email',
  'transactions.receipt.toast.emailFailed': 'Gửi receipt qua email thất bại',
  'transactions.validation.amountRange': 'Số tiền từ phải nhỏ hơn số tiền đến',
  'transactions.detail.title': 'Chi tiết giao dịch',
  'transactions.detail.notFound': 'Không tìm thấy giao dịch',
  'transactions.detail.backToList': 'Quay lại danh sách giao dịch',
  'transactions.batchDetail.title': 'Chi tiết batch',
  'transactions.batchDetail.notFound': 'Không tìm thấy batch',
  'transactions.batchDetail.backToList': 'Quay lại danh sách batch',
  'transactions.batchDetail.section.batchOverview': 'Tổng quan batch',
  'transactions.batchDetail.section.processing': 'Thông tin xử lý',
  'transactions.batchDetail.section.settlementReconciliation':
    'Đối soát quyết toán',
  'transactions.batchDetail.relatedTransactions': 'Giao dịch trong batch',
  'transactions.detail.action.return': 'Quay lại',
  'transactions.detail.action.newSale': 'New Sale',
  'transactions.detail.action.newAuth': 'New Auth',
  'transactions.detail.action.download': 'Tải xuống',
  'transactions.detail.action.downloadCardHolderCopy': 'Bản khách hàng',
  'transactions.detail.action.downloadMerchantCopy': 'Bản merchant',
  'transactions.detail.action.sendEmail': 'Gửi qua email',
  'transactions.detail.action.comingSoon': 'Sắp ra mắt',
  'transactions.detail.field.total': 'Tổng tiền',
  'transactions.detail.field.totalTransactionValue': 'Tổng giá trị giao dịch',
  'transactions.detail.field.approved': 'Được duyệt',
  'transactions.detail.field.transactionType': 'Loại giao dịch',
  'transactions.detail.field.subtotal': 'Tạm tính',
  'transactions.detail.field.tip': 'Tip',
  'transactions.detail.field.tax': 'Thuế',
  'transactions.detail.field.surcharge': 'Phụ phí',
  'transactions.detail.field.discount': 'Giảm giá',
  'transactions.detail.field.shipping': 'Phí vận chuyển',
  'transactions.detail.field.transactionId': 'ID giao dịch',
  'transactions.detail.field.createdAt': 'Tạo lúc',
  'transactions.detail.section.transactionOverview': 'Tổng quan giao dịch',
  'transactions.detail.section.cardInfo': 'Thông tin thẻ',
  'transactions.detail.field.cardNumber': 'Số thẻ',
  'transactions.detail.field.cardExpiration': 'Hết hạn thẻ',
  'transactions.detail.field.cardType': 'Loại thẻ',
  'transactions.detail.field.cvvStatus': 'Trạng thái CVV',
  'transactions.detail.field.authorizationCode': 'Mã ủy quyền',
  'transactions.detail.field.avsStatus': 'Trạng thái AVS',
  'transactions.detail.field.entryMethod': 'Phương thức nhập',
  'transactions.detail.field.responseCode': 'Mã phản hồi',
  'transactions.detail.field.processorResponse': 'Phản hồi processor',
  'transactions.detail.field.settledOn': 'Quyết toán lúc',
  'terminals.title': 'Terminal',
  'terminals.organization.title': 'Tổ chức',
  'terminals.organization.createBranch': 'Tạo chi nhánh',
  'terminals.organization.createMerchant': 'Tạo merchant',
  'terminals.organization.searchPlaceholder': 'Tìm chi nhánh hoặc merchant',
  'terminals.selection.selected': 'Đang chọn:',
  'terminals.selection.branch': 'Chi nhánh: {name}',
  'terminals.selection.merchant': 'Merchant: {name}',
  'terminals.field.epi': 'EPI',
  'terminals.field.name': 'Tên',
  'terminals.field.serial': 'Serial',
  'terminals.field.serialNumber': 'Số serial',
  'terminals.field.merchant': 'Merchant',
  'terminals.field.branch': 'Chi nhánh',
  'terminals.field.status': 'Trạng thái',
  'terminals.field.enrolled': 'Đã enroll',
  'terminals.field.deviceStatus': 'Trạng thái thiết bị',
  'terminals.field.createdDate': 'Ngày tạo',
  'terminals.field.partnerId': 'Partner ID',
  'terminals.field.loadDate': 'Ngày tải',
  'terminals.value.active': 'Hoạt động',
  'terminals.value.disabled': 'Vô hiệu',
  'terminals.value.enrolled': 'Đã enroll',
  'terminals.value.notEnrolled': 'Chưa enroll',
  'terminals.value.addedToFutureX': 'Đã thêm vào FutureX',
  'terminals.action.view': 'Xem',
  'terminals.action.create': 'Tạo terminal',
  'terminals.action.activate': 'Kích hoạt',
  'terminals.action.disable': 'Vô hiệu',
  'terminals.action.publicKey': 'Public Key',
  'terminals.action.reImport': 'Re-import',
  'terminals.action.clearLoadDate': 'Xóa ngày tải',
  'terminals.action.lockDevice': 'Khóa thiết bị',
  'terminals.action.unlockDevice': 'Mở khóa thiết bị',
  'terminals.action.copy': 'Sao chép',
  'terminals.action.close': 'Đóng',
  'terminals.modal.createTitle': 'Tạo terminal',
  'terminals.modal.editTitle': 'Sửa terminal',
  'terminals.warning.selectScopeFirst':
    'Vui lòng chọn chi nhánh hoặc merchant trước',
  'terminals.validation.branchRequired': 'Bắt buộc chọn chi nhánh',
  'terminals.validation.merchantRequired': 'Bắt buộc chọn merchant',
  'terminals.validation.nameRequired': 'Vui lòng nhập tên',
  'terminals.validation.serialLockedAfterEnrollment':
    'Không thể đổi số serial sau khi enroll',
  'terminals.confirm.activateTitle': 'Kích hoạt terminal?',
  'terminals.confirm.activateContent': 'Bạn có chắc muốn kích hoạt "{name}"?',
  'terminals.confirm.disableTitle': 'Vô hiệu terminal?',
  'terminals.confirm.disableContent': 'Bạn có chắc muốn vô hiệu "{name}"?',
  'terminals.confirm.deleteTitle': 'Xóa terminal?',
  'terminals.confirm.deleteContent': 'Bạn có chắc muốn xóa "{name}"?',
  'terminals.confirm.deleteContentWithUndo':
    'Bạn có chắc muốn xóa "{name}"? Hành động này không thể hoàn tác.',
  'terminals.toast.loadOrgFailed': 'Tải cây tổ chức thất bại',
  'terminals.toast.loadFailed': 'Tải terminal thất bại',
  'terminals.toast.created': 'Tạo terminal thành công',
  'terminals.toast.updated': 'Cập nhật terminal thành công',
  'terminals.toast.deleted': 'Xóa terminal thành công',
  'terminals.toast.deleteFailed': 'Xóa terminal thất bại',
  'terminals.toast.activated': 'Kích hoạt terminal thành công',
  'terminals.toast.disabled': 'Vô hiệu terminal thành công',
  'terminals.toast.changeStatusFailed': 'Đổi trạng thái thất bại',
  'terminals.toast.copied': 'Đã sao chép',
  'terminals.employees.title': 'Nhân viên',
  'terminals.employees.header': 'Nhân viên merchant',
  'terminals.employees.field.name': 'Tên',
  'terminals.employees.field.role': 'Vai trò',
  'terminals.employees.field.email': 'Email',
  'terminals.employees.field.phone': 'Điện thoại',
  'terminals.employees.field.passcode': 'Mã passcode',
  'terminals.employees.value.activated': 'Đã kích hoạt',
  'terminals.employees.role.owner': 'Owner',
  'terminals.employees.role.manager': 'Manager',
  'terminals.employees.role.partner': 'Partner',
  'terminals.employees.role.staff': 'Staff',
  'terminals.employees.action.create': 'Tạo nhân viên',
  'terminals.employees.action.viewCode': 'Xem mã',
  'terminals.employees.action.logs': 'Lịch sử',
  'terminals.employees.confirm.deleteTitle': 'Xóa nhân viên?',
  'terminals.employees.confirm.deleteContent': 'Bạn có chắc muốn xóa "{name}"?',
  'terminals.employees.modal.createTitle': 'Tạo nhân viên',
  'terminals.employees.modal.editTitle': 'Sửa nhân viên',
  'terminals.employees.modal.activationCodeTitle': 'Mã kích hoạt{suffix}',
  'terminals.employees.modal.activityLogsTitle': 'Nhật ký hoạt động{suffix}',
  'terminals.employees.validation.nameRequired': 'Vui lòng nhập tên',
  'terminals.employees.validation.passcodeRequired': 'Vui lòng nhập passcode',
  'terminals.employees.validation.passcodeDigits':
    'Passcode phải gồm đúng 4 chữ số',
  'terminals.employees.validation.roleRequired': 'Vui lòng chọn vai trò',
  'terminals.employees.toast.loadFailed': 'Tải nhân viên thất bại',
  'terminals.employees.toast.created': 'Tạo nhân viên thành công',
  'terminals.employees.toast.updated': 'Cập nhật nhân viên thành công',
  'terminals.employees.toast.deleted': 'Xóa nhân viên thành công',
  'terminals.employees.toast.deleteFailed': 'Xóa nhân viên thất bại',
  'terminals.employees.toast.loadActivationCodeFailed':
    'Tải mã kích hoạt thất bại',
  'terminals.detail.notFound': 'Không tìm thấy terminal',
  'terminals.detail.backToList': 'Quay lại danh sách terminal',
  'terminals.detail.tab.overview': 'Tổng quan',
  'terminals.detail.tab.parameters': 'Tham số',
  'terminals.detail.tab.processors': 'Processor',
  'terminals.detail.tab.enrollments': 'Enrollment',
  'terminals.detail.tab.merchantActivityLogs': 'Nhật ký hoạt động merchant',
  'terminals.detail.publicKeyTitle': 'Public Key của Terminal',
  'terminals.detail.confirm.addToFutureXTitle': 'Thêm terminal vào FutureX?',
  'terminals.detail.confirm.addToFutureXContent':
    'Re-import terminal "{name}" sang tích hợp đối tác?',
  'terminals.detail.confirm.clearLoadDateTitle': 'Xóa ngày tải?',
  'terminals.detail.confirm.clearLoadDateContent':
    'Xóa ngày tải của terminal "{name}"?',
  'terminals.detail.confirm.lockTitle': 'Khóa thiết bị này?',
  'terminals.detail.confirm.lockContent': 'Khóa thủ công terminal "{name}"?',
  'terminals.detail.confirm.unlockTitle': 'Mở khóa thiết bị này?',
  'terminals.detail.confirm.unlockContent':
    'Mở khóa thủ công terminal "{name}"?',
  'terminals.detail.toast.actionFailed': 'Thực hiện thao tác thất bại',
  'terminals.detail.toast.reImportRequested': 'Đã gửi yêu cầu re-import',
  'terminals.detail.toast.loadDateCleared': 'Đã xóa ngày tải',
  'terminals.detail.toast.manualLockSent': 'Đã gửi yêu cầu khóa thủ công',
  'terminals.detail.toast.manualUnlockSent': 'Đã gửi yêu cầu mở khóa thủ công',
  'terminals.logs.field.fromDate': 'Từ ngày',
  'terminals.logs.field.toDate': 'Đến ngày',
  'terminals.logs.field.employee': 'Nhân viên',
  'terminals.logs.field.activity': 'Hoạt động',
  'terminals.logs.field.logTime': 'Thời gian log',
  'terminals.logs.field.ipAddress': 'Địa chỉ IP',
  'terminals.logs.placeholder.searchTerminal':
    'Nhân viên, hoạt động, địa chỉ IP',
  'terminals.logs.placeholder.searchEmployee': 'Hoạt động, địa chỉ IP',
  'terminals.snapshot.title': 'Snapshot gần nhất',
  'terminals.snapshot.field.snapshotAt': 'Thời điểm snapshot',
  'terminals.snapshot.field.cpuUsage': 'Mức dùng CPU',
  'terminals.snapshot.field.ramUsage': 'Mức dùng RAM',
  'terminals.snapshot.field.storageUsage': 'Mức dùng bộ nhớ',
  'terminals.snapshot.field.batteryUsage': 'Mức dùng pin',
  'terminals.snapshot.field.androidVersion': 'Phiên bản Android',
  'terminals.snapshot.field.firmwareVersion': 'Phiên bản Firmware',
  'terminals.snapshot.field.ssid': 'SSID',
  'terminals.snapshot.field.latitude': 'Vĩ độ',
  'terminals.snapshot.field.longitude': 'Kinh độ',
  'terminals.processors.modal.createTitle': 'Tạo processor',
  'terminals.processors.modal.editTitle': 'Sửa processor',
  'terminals.processors.field.processor': 'Processor',
  'terminals.processors.field.mid': 'MID',
  'terminals.processors.field.tid': 'TID',
  'terminals.processors.field.devId': 'Dev ID',
  'terminals.processors.field.vNumber': 'V Number',
  'terminals.processors.field.bin': 'BIN',
  'terminals.processors.field.agent': 'Agent',
  'terminals.processors.field.chain': 'Chain',
  'terminals.processors.field.locationNumber': 'Location Number',
  'terminals.processors.field.store': 'Store',
  'terminals.processors.field.categoryCode': 'Category Code',
  'terminals.processors.field.default': 'Mặc định',
  'terminals.processors.confirm.deleteTitle': 'Xóa processor?',
  'terminals.processors.confirm.deleteContent':
    'Bạn có chắc muốn xóa "{name}"?',
  'terminals.processors.action.add': 'Thêm processor',
  'terminals.processors.toast.created': 'Tạo processor thành công',
  'terminals.processors.toast.updated': 'Cập nhật processor thành công',
  'terminals.processors.toast.deleted': 'Xóa processor thành công',
  'terminals.enrollments.modal.createTitle': 'Tạo enrollment',
  'terminals.enrollments.modal.editTitle': 'Sửa enrollment',
  'terminals.enrollments.field.activationCode': 'Mã kích hoạt',
  'terminals.enrollments.field.otpStart': 'OTP bắt đầu',
  'terminals.enrollments.field.otpEnd': 'OTP kết thúc',
  'terminals.enrollments.field.type': 'Loại',
  'terminals.enrollments.modal.field.otpStartDate': 'Ngày bắt đầu OTP',
  'terminals.enrollments.modal.field.otpEndDate': 'Ngày kết thúc OTP',
  'terminals.enrollments.field.used': 'Đã dùng',
  'terminals.enrollments.action.add': 'Thêm enrollment',
  'terminals.enrollments.action.addAgent': 'Agent Enrollment',
  'terminals.enrollments.toast.created': 'Tạo enrollment thành công',
  'terminals.enrollments.toast.agentCreated': 'Tạo agent enrollment thành công',
  'terminals.enrollments.toast.updated': 'Cập nhật enrollment thành công',
  'terminals.enrollments.toast.deleted': 'Xóa enrollment thành công',
  'terminals.parameters.section.dualPricing': 'Dual Pricing',
  'terminals.parameters.section.tip': 'Tip',
  'terminals.parameters.section.receipt': 'Biên lai',
  'terminals.parameters.section.authorizationAndTax': 'Ủy quyền và thuế',
  'terminals.parameters.section.otherOptions': 'Tùy chọn khác',
  'terminals.parameters.field.enableDualPricing': 'Bật Dual Pricing',
  'terminals.parameters.field.enteredAmountMode': 'Chế độ nhập số tiền',
  'terminals.parameters.field.cashDiscountPercentage':
    'Phần trăm giảm giá tiền mặt',
  'terminals.parameters.field.enableTip': 'Bật tip',
  'terminals.parameters.field.tipPercent1': 'Tip % 1',
  'terminals.parameters.field.tipPercent2': 'Tip % 2',
  'terminals.parameters.field.tipPercent3': 'Tip % 3',
  'terminals.parameters.field.tipPercent4': 'Tip % 4',
  'terminals.parameters.field.skipReceiptScreen': 'Bỏ qua màn hình biên lai',
  'terminals.parameters.field.autoPrintCardHolderCopy':
    'Tự động in bản sao chủ thẻ',
  'terminals.parameters.field.autoPrintMerchantCopy':
    'Tự động in bản sao merchant',
  'terminals.parameters.field.receiptFooter': 'Chân trang biên lai',
  'terminals.parameters.field.receiptDisclaimers': 'Disclaimer biên lai',
  'terminals.parameters.placeholder.disclaimerLine': 'Dòng disclaimer',
  'terminals.parameters.action.addDisclaimer': 'Thêm disclaimer',
  'terminals.parameters.field.enableTax': 'Bật thuế',
  'terminals.parameters.field.salesTaxPercentage': 'Phần trăm thuế bán hàng',
  'terminals.parameters.field.enableTaxForCash': 'Bật thuế cho tiền mặt',
  'terminals.parameters.field.enableTaxForQr': 'Bật thuế cho QR',
  'terminals.parameters.field.enableRemoveTax': 'Bật bỏ thuế',
  'terminals.parameters.field.qrDiscountPercentage': 'Phần trăm giảm giá QR',
  'terminals.parameters.field.tipType': 'Loại tiền tip',
  'terminals.parameters.field.tipAmount': 'Tiền tip {index}',
  'terminals.parameters.field.forceSignature': 'Bắt buộc chữ ký',
  'terminals.parameters.field.enableDebitAids': 'Bật Debit AIDs',
  'terminals.parameters.field.enableGoCheckIn': 'Bật Go CheckIn',
  'terminals.parameters.field.enableUnreferencedRefund':
    'Bật hoàn tiền không tham chiếu',
  'terminals.parameters.field.enableVoidInHomeScreen':
    'Bật Void tại màn hình chính',
  'terminals.parameters.action.save': 'Lưu tham số',
  'terminals.parameters.toast.loadFailed': 'Tải cấu hình terminal thất bại',
  'terminals.parameters.toast.updated': 'Cập nhật cấu hình thành công',
  'terminals.parameters.toast.updateFailed': 'Cập nhật cấu hình thất bại',
};
